export const alternatives = ['A', 'B', 'C', 'D', 'E'];
export default alternatives;
